import React from 'react';

import './troubleshootingstyles.css';

function Troubleshooting() {
  return (
    <>
      
      <div className="troubleshooting-container">
        <h1>Troubleshooting</h1>
        <p>Encountering issues? Here are some common problems and their solutions. If you're still having trouble, reach out to our support team.</p>
        
        <div className="faq-section">
          <div className="faq-item">
            <input type="checkbox" id="faq1" className="faq-checkbox" />
            <label htmlFor="faq1" className="faq-title">Problem 1: Cannot Load the Page</label>
            <div className="faq-content">
              <p>Solution: Check your internet connection and refresh the page. If the problem persists, clear your browser cache and cookies, and try again.</p>
            </div>
          </div>
          
          <div className="faq-item">
            <input type="checkbox" id="faq2" className="faq-checkbox" />
            <label htmlFor="faq2" className="faq-title">Problem 2: Images Not Displaying</label>
            <div className="faq-content">
              <p>Solution: Ensure that the image links are correct and that your browser supports the image format. You might also want to check your ad blocker settings as they can sometimes block images.</p>
            </div>
          </div>

          <div className="faq-item">
            <input type="checkbox" id="faq3" className="faq-checkbox" />
            <label htmlFor="faq3" className="faq-title">Problem 3: Slow Page Load</label>
            <div className="faq-content">
              <p>Solution: Check if other websites are loading slowly too. If they are, the issue might be with your internet connection. If it’s just this site, clear your cache or try accessing the site from another browser.</p>
            </div>
          </div>

          <div className="faq-item">
            <input type="checkbox" id="faq4" className="faq-checkbox" />
            <label htmlFor="faq4" className="faq-title">Problem 4: Form Submission Error</label>
            <div className="faq-content">
              <p>Solution: Ensure all required fields are filled out correctly. If the issue continues, try submitting the form in a different browser or device.</p>
            </div>
          </div>
        </div>
      </div>
      
    </>
  );
}

export default Troubleshooting;
